export default __webpack_public_path__ + "static/media/delivery_green.95b66745.svg";